import { Dialog, DialogButton, DialogContentText } from '@/components/Dialog';
import { MAX_SELECTED_SYMBOLS } from '@/constants/constants';

const LimitDialog = ({ handleClose, open }: { handleClose: () => void; open: boolean }) => {
  return (
    <Dialog
      buttons={<DialogButton onClick={handleClose}>Ok</DialogButton>}
      open={open}
      title='Too many items!'
      onClose={handleClose}
    >
      <DialogContentText>Please select fewer than {MAX_SELECTED_SYMBOLS}.</DialogContentText>
    </Dialog>
  );
};

export default LimitDialog;
